module.exports = __webpack_public_path__ + "img/redo.04830824.svg";